export default __webpack_public_path__ + "static/media/category.d03d2b1b.svg";